import { useState } from 'react';
// @mui
import { useTheme } from '@mui/material/styles';
import { TableRow, TableCell, Typography, MenuItem } from '@mui/material';
// components
import { TableMoreMenu } from '../../../components/table';
import { MyAvatar } from 'src/components/common';

// ----------------------------------------------------------------------

export default function DuelLeaderboardTableRow({ row, rowNumber, selected, onEditRow, openLeaderboardModal }) {
  const { avatar, ProfileName, ProfileLastname, Ranked, Mobile } = row;

  const [openMenu, setOpenMenuActions] = useState(null);

  const theme = useTheme();

  const handleOpenMenu = (event) => {
    setOpenMenuActions(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setOpenMenuActions(null);
  };

  return (
    <TableRow hover selected={selected}>
      <TableCell align="center">
        <Typography variant="body1">{rowNumber}</Typography>
      </TableCell>

      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <MyAvatar alt={`${ProfileName} ${ProfileLastname}`} sx={{ mr: 2 }} src={avatar} />
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{ProfileName || '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{ProfileLastname || '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{Mobile || '-'}</Typography>
      </TableCell>

      <TableCell align="center">
        <Typography variant="body1">{Ranked}</Typography>
      </TableCell>
    </TableRow>
  );
}
